import $axios from '@/api/apiPublic';

const getRebateBrokers = async () => {
  // const response = await $axios.get('broker/rebate?limit=20&offset=0')
  const response = await $axios.get('broker/rebate');
  return response;
};

export default {
  getRebateBrokers,
};
